import { type ModalKeys } from "@/lib/store/modal";
import { ModalDeclarationPrompt } from "./app/declaration-prompt";
import { ModalAppExplainer } from "./app/explainer";
import { ModalProfileNudge } from "./app/profile-nudge";
import { ModalPushNotificationsDenied } from "./app/push-notifications-denied";

export function ModalProvider() {
  return (
    <>
      {Object.entries({
        appExplainer: ModalAppExplainer,
        pushNotificationsDenied: ModalPushNotificationsDenied,
        profileNudge: ModalProfileNudge,
        declarationPrompt: ModalDeclarationPrompt,
      } satisfies Record<ModalKeys, () => JSX.Element>).map(([key, Component]) => (
        <Component key={key} />
      ))}
    </>
  );
}
